import { render, staticRenderFns } from "./LoanCollateralAssetProductFieldsEdit.vue?vue&type=template&id=f8a1f0c0&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetProductFieldsEdit.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetProductFieldsEdit.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetProductFieldsEdit.vue?vue&type=style&index=0&id=f8a1f0c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a1f0c0",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetProductFieldsEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports